"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleTab = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var styles = __importStar(require("./ContentSidebarToggleTab.css"));
var classnames_1 = __importDefault(require("classnames"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var ToggleTab = function () {
    var _a = (0, inversify_react_1.useInjection)("contentSidebarViewStore"), toggleSidebar = _a.toggle, isSidebarOpen = _a.isOpen;
    var isShowingFolders = (0, inversify_react_1.useInjection)("contentSidebarLibraryViewStore").isShowingFolders;
    var _b = __read((0, react_1.useState)("none"), 2), offset = _b[0], setOffset = _b[1];
    (0, react_1.useEffect)(function () {
        if (isShowingFolders && isSidebarOpen) {
            setOffset("wider");
        }
        else {
            setOffset(isSidebarOpen ? "default" : "none");
        }
    }, [isSidebarOpen, isShowingFolders]);
    var isMac = /mac/i.test(window.navigator.userAgent);
    var cmdOrCtrl = isMac ? "⌘" : "Ctrl";
    var clipId = "toggle-tab-clip-".concat((0, utils_1.randomString)());
    var shadowId = "toggle-tab-shadow-".concat((0, utils_1.randomString)());
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", className: (0, classnames_1.default)(tokens_1.lightTheme, styles.container({ offset: offset })) },
        react_1.default.createElement(kaleidoscope_1.Tooltip, { className: styles.toggleTooltip, position: kaleidoscope_1.TooltipPosition.Right, offset: -16, content: react_1.default.createElement(react_1.default.Fragment, null,
                isSidebarOpen ? "Hide library" : "Library",
                " ",
                react_1.default.createElement(kaleidoscope_1.Label, { theme: "dark", secondary: true, size: "s" },
                    cmdOrCtrl,
                    "+\\")) },
            react_1.default.createElement("button", { onClick: toggleSidebar, className: styles.buttonOverride, "data-testid": "content-sidebar-toggle" },
                react_1.default.createElement("svg", { className: styles.svg, xmlns: "http://www.w3.org/2000/svg", width: "40", height: "90", fill: "none", viewBox: "0 0 40 90" },
                    react_1.default.createElement("g", { clipPath: "url(#".concat(clipId, ")") },
                        react_1.default.createElement("g", { filter: "url(#".concat(shadowId, ")") },
                            react_1.default.createElement("path", { fill: tokens_1.tokens.color.surface, d: "M1 7c0 .553 0 .83.012 1.098a12 12 0 0 0 2.537 6.857c.165.211.345.421.705.841l4.095 4.777c1.74 2.03 2.61 3.045 3.225 4.192.523.976.91 2.019 1.147 3.1.279 1.272.279 2.609.279 5.282v23.706c0 2.673 0 4.01-.28 5.281a11.999 11.999 0 0 1-1.146 3.1c-.616 1.148-1.486 2.163-3.225 4.192l-4.095 4.778c-.36.42-.54.63-.705.841a12 12 0 0 0-2.537 6.857C1 82.17 1 82.447 1 83V7Z" })),
                        react_1.default.createElement("path", { fill: tokens_1.tokens.color.surface, d: "M0 0h1v90H0z" })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: clipId },
                            react_1.default.createElement("path", { fill: tokens_1.tokens.color.surface, d: "M0 0h40v90H0z" })),
                        react_1.default.createElement("filter", { id: shadowId, width: "84", height: "148", x: "-35", y: "-29", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
                            react_1.default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                            react_1.default.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                            react_1.default.createElement("feOffset", null),
                            react_1.default.createElement("feGaussianBlur", { stdDeviation: "10" }),
                            react_1.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" }),
                            react_1.default.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_2995_149407" }),
                            react_1.default.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                            react_1.default.createElement("feOffset", null),
                            react_1.default.createElement("feGaussianBlur", { stdDeviation: "5" }),
                            react_1.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" }),
                            react_1.default.createElement("feBlend", { in2: "effect1_dropShadow_2995_149407", result: "effect2_dropShadow_2995_149407" }),
                            react_1.default.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                            react_1.default.createElement("feOffset", null),
                            react_1.default.createElement("feGaussianBlur", { stdDeviation: "18" }),
                            react_1.default.createElement("feColorMatrix", { values: "0 0 0 0 0.0705882 0 0 0 0 0.0784314 0 0 0 0 0.137255 0 0 0 0.1 0" }),
                            react_1.default.createElement("feBlend", { in2: "effect2_dropShadow_2995_149407", result: "effect3_dropShadow_2995_149407" }),
                            react_1.default.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                            react_1.default.createElement("feOffset", null),
                            react_1.default.createElement("feGaussianBlur", { stdDeviation: "1.5" }),
                            react_1.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                            react_1.default.createElement("feBlend", { in2: "effect3_dropShadow_2995_149407", result: "effect4_dropShadow_2995_149407" }),
                            react_1.default.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                            react_1.default.createElement("feOffset", null),
                            react_1.default.createElement("feGaussianBlur", { stdDeviation: ".5" }),
                            react_1.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
                            react_1.default.createElement("feBlend", { in2: "effect4_dropShadow_2995_149407", result: "effect5_dropShadow_2995_149407" }),
                            react_1.default.createElement("feBlend", { in: "SourceGraphic", in2: "effect5_dropShadow_2995_149407", result: "shape" })))),
                isSidebarOpen ? (react_1.default.createElement(icons_1.ChevronLeft, { size: icons_1.IconSize.Small, className: styles.chevron })) : (react_1.default.createElement(icons_1.ChevronRight, { size: icons_1.IconSize.Small, className: styles.chevron }))))));
};
exports.ToggleTab = ToggleTab;
